import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export async function exportLawyerExcelV2(data = []) {
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet("รายงานสัญญาที่ส่งทนาย");

  ws.columns = [
    { header: "ลำดับ", key: "no", width: 8 },
    { header: "รหัสลูกหนี้", key: "borrCode", width: 18 },
    { header: "ชื่อ-นามสกุล", key: "name", width: 30 },
    { header: "สถานะคดี", key: "status", width: 22 },
    { header: "ทนายที่รับผิดชอบ", key: "lawyerName", width: 22 },
    { header: "เลขที่สัญญา", key: "runningNo", width: 28 },
    { header: "เลขที่บัญชี", key: "accountNo", width: 28 },
    { header: "เงินต้นรวม", key: "principal", width: 16 },
    { header: "ดอกเบี้ย SCB รวม", key: "interest", width: 16 },
  ];

  data.forEach((r, i) => {
    const contracts = Array.isArray(r.stock_contracts) ? r.stock_contracts : [];
    const totalPrincipal = contracts.reduce(
      (sum, c) => sum + Number(c.principal_amount || 0),
      0,
    );
    const totalInterest = contracts.reduce(
      (sum, c) => sum + Number(c.interest || 0),
      0,
    );

    const excelRow = ws.addRow({
      no: i + 1,
      borrCode: r.borr_code || "-",
      name: r.full_name || "-",
      status: r.statusLabel || "-",
      lawyerName: r.lawyerDisplayName || "-",
      runningNo:
        contracts
          .map((c) => c.running_no)
          .filter(Boolean)
          .join(", ") || "-",
      accountNo:
        contracts
          .map((c) => c.account_no)
          .filter(Boolean)
          .join(", ") || "-",
      principal: totalPrincipal,
      interest: totalInterest,
    });

    excelRow.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    excelRow.getCell("principal").numFmt = "#,##0.00";
    excelRow.getCell("interest").numFmt = "#,##0.00";
  });

  const header = ws.getRow(1);
  header.height = 20;
  header.eachCell((cell) => {
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEFEFEF" },
    };
    cell.border = {
      top: { style: "medium" },
      left: { style: "thin" },
      bottom: { style: "medium" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `รายงานสัญญาที่ส่งทนาย_${dayjs().format("DD_MM_YY")}.xlsx`);
}
